import { useDocumentWithFilesQuery } from '../../../domains/documents/queries/useDocumentWithFilesQuery';
import type { IDocument } from '../../../types';

type IUseDocumentWithFile = {
  document: IDocument | undefined;
};

export const useDocumentWithFile = ({ document }: IUseDocumentWithFile) => {
  const { data: documentWithFile, isLoading, isFetching } = useDocumentWithFilesQuery(document?.id);

  return {
    documentWithFile: documentWithFile ?? null,
    isLoading,
    isFetching,
  };
};
